import { DestroyRef, Directive, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { InstrumentDetailFacade, InstrumentDetailsService } from '@zero/instrument-details/domain';
import { InstrumentType } from '@zero/shared/util-models';
import { combineLatest, distinctUntilChanged, filter, map } from 'rxjs';

@Directive()
export class InstrumentDetailsPageBase {
  public homeUrl!: string;
  public isin!: string;
  public readonly activatedRoute = inject(ActivatedRoute);
  public readonly service = inject(InstrumentDetailsService);
  public readonly InstrumentType = InstrumentType;
  public readonly instrumentDetailFacade = inject(InstrumentDetailFacade);

  readonly #destroyRef = inject(DestroyRef);

  protected readonly router = inject(Router);

  public readonly displayPosition$ = combineLatest({
    hasAssetTimeline: this.instrumentDetailFacade.assetTimelineInfo$,
    position: this.service.position$,
  }).pipe(
    map(({ position, hasAssetTimeline }) => Boolean(position || hasAssetTimeline)),
    distinctUntilChanged(),
    takeUntilDestroyed(this.#destroyRef),
  );

  public init() {
    this.activatedRoute.params
      .pipe(
        map((params) => params['id']),
        filter((id) => !!id),
        distinctUntilChanged(),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe((isin) => {
        if (!isin) {
          this.router.navigate([this.homeUrl]);
        } else {
          this.destroy();
          this.isin = isin;
          this.service.loadInstrument(isin);
          this.instrumentDetailFacade.loadAssetTimelineInfo(isin);
        }
      });
  }

  public destroy(): void {
    this.service.clear();
    this.instrumentDetailFacade.clear();
  }
}
